// The data-access layer (Stage B, brief section 3). Webpack only: this file wires the
// real db in; everything under it takes db as an argument so it loads under node --test.
// New Firestore calls in any branch go through here once this is merged.
import { db } from '@/main';
import usersRepository from './repositories/users';

const getDb = () => db;

export default {
    users: usersRepository(getDb)
};


// WEBPACK FOOTER //
// ./src/data/index.js